import { Text, chakra } from '@chakra-ui/react';
import React from 'react';

import { Alert } from 'toolkit/chakra/alert';
import { Link } from 'toolkit/chakra/link';
import { Skeleton } from 'toolkit/chakra/skeleton';
import { TableCell, TableRow } from 'toolkit/chakra/table';

interface InjectedProps {
  content: React.ReactNode;
}

interface Props {
  type?: 'transaction' | 'token_transfer' | 'deposit' | 'block';
  children?: (props: InjectedProps) => React.JSX.Element;
  className?: string;
  url?: string;
  showErrorAlert?: boolean;
  num?: number;
  isLoading?: boolean;
}

const SocketNewItemsNotice = chakra(({ children, className, url, num, showErrorAlert, type = 'transaction', isLoading }: Props) => {
  const handleLinkClick = React.useCallback(() => {
    window.location.reload();
  }, []);

  const alertContent = (() => {
    if (showErrorAlert) {
      return 'به‌روزرسانی زنده موقتاً با تأخیر انجام می‌شود';
    }

    let singularName;
    let pluralName;

    switch (type) {
      case 'token_transfer':
        singularName = 'انتقال توکن';
        pluralName = 'انتقال توکن';
        break;
      case 'deposit':
        singularName = 'واریز';
        pluralName = 'واریز';
        break;
      case 'block':
        singularName = 'بلاک';
        pluralName = 'بلاک';
        break;
      default:
        singularName = 'تراکنش';
        pluralName = 'تراکنش';
        break;
    }

    if (!num) {
      return `در حال بررسی ${ pluralName }‌های جدید...`;
    }

    return (
      <>
        <Link href={ url } onClick={ !url ? handleLinkClick : undefined }>{ num.toLocaleString() } { singularName } جدید</Link>
        <Text whiteSpace="pre"> دریافت شده است</Text>
      </>
    );
  })();

  const content = !isLoading ? (
    <Alert
      className={ className }
      status="warning_table"
      px={ 4 }
      py="6px"
      fontSize="sm"
    >
      { alertContent }
    </Alert>
  ) : <Skeleton className={ className } h="36px" loading/>;

  return children ? children({ content }) : content;
});

export default SocketNewItemsNotice;

export const Desktop = ({ ...props }: Props) => {
  return (
    <SocketNewItemsNotice
      borderRadius={ props.isLoading ? 'sm' : 0 }
      h={ props.isLoading ? 5 : 'auto' }
      maxW={ props.isLoading ? '215px' : undefined }
      w="100%"
      mx={ props.isLoading ? 4 : 0 }
      my={ props.isLoading ? '6px' : 0 }
      { ...props }
    >
      { ({ content }) => <TableRow><TableCell colSpan={ 100 } p={ 0 } _first={{ p: 0 }} _last={{ p: 0 }}>{ content }</TableCell></TableRow> }
    </SocketNewItemsNotice>
  );
};

export const Mobile = ({ ...props }: Props) => {
  return (
    <SocketNewItemsNotice
      borderBottomRadius={ 0 }
      { ...props }
    />
  );
};
